export const MESSENGER_OPEN_EVENT = 'messenger:open';

export const ASSISTANT_REQUEST_CLOSE_EVENT = 'assistant:request-close';

export type MessengerOpenDetail = {
    guid?: string;
    deeplink?: string;
    pasteText?: string;
    pasteForce?: boolean;
};

export function openMessenger(detail?: MessengerOpenDetail): void {
    window.dispatchEvent(new CustomEvent(MESSENGER_OPEN_EVENT, { detail }));
}
